import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import qs from 'query-string';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../config';
import Follow from '../../components/follow';
import UnitStats from '../../components/unitstats';
import UnitInfo from '../../components/unitinfo';
import UnitSCBStats from '../../components/unitscbstats';
import UnitFeed from '../../components/unitfeed';
import Spinner from  '../../components/spinner';
import withFetch from '../../hoc/withFetch';
import Feedback from './feedback';
//import SaveButton from '../report/save-button';
import './styles.scss';

class Unit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            unitData: null,
            watcherIsLoading: false,
            isError: false,
            errorType: null
        }
    }

    async requestInitialData(route) {
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/units/${route.params.unitId}/extended`); 
        if (!res.ok) {
            
            if (res.status === 403) {
                this.setState({
                    isLoading: false,
                    isError: true,
                    errorType: 403
                    
                });
            }

            //handle 404
        }
        return await res.json();
    }

    async readNotification(notificationId) {
        const headers = await this.getTokenHeaders();

        const rawResponse = await fetch(`${REACT_APP_API_BASE}/online/notifications/${notificationId}/read`, {
            method: 'POST',
            headers: headers
        });

        if (!rawResponse.ok) {
        }
        this.props.refreshMenu();

        return true;   
    }

    async componentDidMount() {
        //setTimeout(async () => {
        const unitData = await this.requestInitialData(this.props.match);

        const { location } = this.props;
        const query = qs.parse(location.search);

        if (query.notificationId) {
            await this.readNotification(query.notificationId);
        }

        this.setState({
            unitData,
            isLoading: false
        });
        //}, 500);
        
    }

    createZipCodeRange(zip, range) {
        if (range === 1) {
            return `${zip.substring(0, 1)}0000-${zip.substring(0, 1)}9999`;
        }

        if (range === 2) {
            return `${zip.substring(0, 2)}000-${zip.substring(0, 2)}999`;
        }

        if (range === 3) {
            return `${zip.substring(0, 3)}00-${zip.substring(0, 3)}99`;
        }

        return zip;
    }

    back(e) {
        if (this.props.location.state && this.props.location.state.from) {
            return true;
        }
        
        e.preventDefault();
        this.props.history.goBack();
    }

    getBackLink() {
        if (this.props.location.state && this.props.location.state.from) {
            return {
                url: `${this.props.location.state.from.pathname}${this.props.location.state.from.search}`,
                text: 'Tillbaka till listan'
            };
        } else {
            return {
                url: '/search',
                text: 'Tillbaka'
            }
        }
    }

    async getTokenHeaders() {
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        return headers;
    }

    async toggleWatcher() {
        if (!this.state.unitData) return;

        this.setState({
            watcherIsLoading: true
        });

        const headers = await this.getTokenHeaders();

        const rawResponse = await fetch(`${REACT_APP_API_BASE}/units/${this.state.unitData.id}/adddeletewatch`, {
            method: 'POST',
            headers: headers
        });

        if (rawResponse.ok) {
            const unitData = await this.requestInitialData(this.props.match);
            setTimeout(() => {
                this.setState({
                    unitData,
                    watcherIsLoading: false,
                    watcherIsSaved: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            watcherIsSaved: false
                        });
                    }, 4000); 
                });
            }, 500);
            //const result = await rawResponse.json();
        }
        //https://delfiwebapiqa.azurewebsites.net/units/{id}/adddeletewatch*/
    }
    
    render() {
        const { unitData } = this.state;

        if (this.state.isError && this.state.errorType === 403) {
            return (
                <section className={classNames({
                    'unit': true
                })}>
                    <div className="unit__no-access">
                        <header className="unit__no-access-header">
                            <h1>Enheten ingår inte i ditt abonnemang</h1>
                        </header>
                        <div className="unit__no-access-image"></div>
                        <div className="unit__no-access-text">
                            <a href="mailto:info@delfi.se">Kontakta oss för att få tillgång till enheten</a>
                        </div>
                    </div>
                </section>
            );
        }

        return (
            <>
                <section className={classNames({
                    'unit': true,
                    'unit--is-loading': this.state.isLoading
                })}>
                    <header className="unit__header">
                        <div className="unit__header-content">
                    
                            <section className="breadcrumb breadcrumb--min-padding">
                                <Link className="breadcrumb__item" title="Tillbaka" to={this.getBackLink().url} onClick={(e) => this.back(e)}>{this.getBackLink().text}</Link>
                            </section>

                            <h1 className="unit__header-heading"><span>{ unitData && unitData.UnitName}&nbsp;</span></h1>
                            <p className="unit__header-subheading"><span>{unitData && `Delfi-ID ${unitData.DelfiId}`}&nbsp;</span></p>
                        </div>
                        <Follow toggleWatcher={() => this.toggleWatcher()} 
                                watcherExists={this.state.unitData && this.state.unitData.WatcherExists} 
                                watcherIsLoading={this.state.watcherIsLoading} 
                                watcherIsSaved={this.state.watcherIsSaved} />
                    </header>
                    <UnitStats unitData={unitData} />
                    <div className="unit__content">
                        <UnitInfo unitData={unitData}  />
                        <UnitSCBStats unitData={unitData} selections={[{
                                        id: 1,
                                        param: 'postalCodes',
                                        name: '5-siffrigt postnummer',
                                        value: unitData && unitData.LayerSelection && unitData.LayerSelection.postalCodes[0]
                                    }, {
                                        id: 2,
                                        param: 'postalCodes',
                                        name: '3-siffrigt postnummer',
                                        value: unitData && unitData.LayerSelection && this.createZipCodeRange(unitData.LayerSelection.postalCodes[0], 3)
                                    }, {
                                        id: 3,
                                        param: 'postalCodes',
                                        name: '2-siffrigt postnummer',
                                        value: unitData && unitData.LayerSelection && this.createZipCodeRange(unitData.LayerSelection.postalCodes[0], 2)
                                    }, {
                                        id: 4,
                                        param: 'postalCodes',
                                        name: '1-siffrigt postnummer',
                                        value: '40000-49999'
                                    }, {
                                        id: 5,
                                        param: 'county',
                                        name: 'Län',
                                        value: unitData && unitData.LayerSelection && unitData.LayerSelection.county[0]
                                    }, {
                                        id: 6,
                                        param: 'municipality',
                                        name: 'Kommun',
                                        value: unitData && unitData.LayerSelection && unitData.LayerSelection.municipality[0]
                                    }, {
                                        id: 7,
                                        param: 'aregion',
                                        name: 'A-region',
                                        value: unitData && unitData.LayerSelection && unitData.LayerSelection.aregion[0]
                                    }, {
                                        id: 8,
                                        param: 'locality',
                                        name: 'Postort',
                                        value: unitData && unitData.LayerSelection && unitData.LayerSelection.locality[0]
                                    }]}  />
                        <UnitFeed {...unitData} />
                    </div>
                    <footer className="export-footer">
                        <button type="button" className="form__button form__button--small" onClick={() => window.print()}>Skriv ut</button>
                        <Feedback {...this.props} />
                    </footer>
                </section>
                <Spinner isLoading={this.state.isLoading} />
            </>
        );
    }
}

export default withFetch(Unit);